import React, { Component } from 'react';
import { Dialog } from "@material-ui/core";
import axios from 'axios';
import './NewGalleryDialog.scss';
import i18n from '../../i18n';
import { connect } from 'react-redux';
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { Container } from '../GalleryDialog/GalleryDialog.style';
import { GetUserProfileURL } from '../../Interface';
import { _getTemplateById } from '../../Home';
import FormatHelper from '../../utils/FormatHelper'

import ReportVideoPopup from '../../SharedLinkPage/ReportVideoPopup/ReportVideoPopup';
import OneBtnDialog from "../../Common/OneBtnDialog/OneBtnDialog";
import ShareDialog from '../../UserPage/MyVideo/ShareDialog/ShareDialog';
import DesignSelectPopup from '../../DesignSelect/DesignSelectPopup/DesignSelectPopup';
import EditHashTagDialog from '../GalleryDialog/EditHashTagDialog'
import CommentArea from './CommentArea/CommentArea';
import CommentReportDialog from '../CommentReportDialog/CommentReportDialog';
import TwoBtnDialog from '../../Common/TwoBtnDialog/TwoBtnDialog';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

class NewGalleryDialog extends Component {

    constructor(props) {
        super(props)
        this.state = {
            reportValue: "a",
            isOpenReportPopup: false,
            isBtnDialogOpened: false,
            dialogType: "shareSuccess",
            isOpenShareDialog: false,
            commentId: null,
            isOpenEditHashtagDialog: false,
            hashtagString: '',
            textValue: '',
            isOpenCommentReportPopup: false,
            commentReportValue: "a",
            isOpenRemoveCommentTwoButton: false,
        }
        this.CommentAreaRef = undefined
    }

    setCommentArea = (ref) => {
        this.CommentAreaRef = ref
    }
    setFocus = () => {

    }

    getTemplateById = async (videoId) => { return _getTemplateById(videoId) }

    getNoWhiteSpacehashTags = () => {
        const { hashtagString } = this.state
        const { videoInfo } = this.props

        if (!videoInfo || !hashtagString) return ''

        let noWhiteSpaceHashTag = hashtagString
        if (noWhiteSpaceHashTag) noWhiteSpaceHashTag = noWhiteSpaceHashTag.replace(/ /gi, '')
        return noWhiteSpaceHashTag
    }

    sendReport = async () => {
        const token = localStorage.getItem("token")
        const { _id } = this.props.videoInfo
        const { reportValue } = this.state
        try {
            const result = await axios.post(`${GetBaseUrl()}/api/video/report`, { id: _id, value: reportValue }, { headers: { Authorization: `Bearer ${token}` } })
            if (result.data && result.data.message === "success") {
                this.handleClickCloseVideoReport()
                this.setState({
                    dialogType: "reportSucces",
                    isBtnDialogOpened: true
                })
            } else if (result.data && result.data.message === "already") {
                this.handleClickCloseVideoReport()
                this.setState({
                    dialogType: "reportAlready",
                    isBtnDialogOpened: true
                })
            }
            if (result && result.status === 404) {
                this.setState({
                    dialogType: "severError",
                    isBtnDialogOpened: true
                })
            }
        } catch (err) {
            this.setState({
                dialogType: "severError",
                isBtnDialogOpened: true
            })
        }
    }

    handleClickFollow = async (userShareId, isUnfollow = false) => {
        const { videoInfo, loginRequest, updateVideoInfo } = this.props
        if (!userShareId) return

        const token = localStorage.getItem("token")
        if (!token) return loginRequest()

        const { _id } = videoInfo
        try {
            if (isUnfollow) {
                await axios.delete(`${GetBaseUrl()}/apis/follow/${userShareId}`, { headers: { Authorization: `Bearer ${token}` } })
                await updateVideoInfo(_id)
            }
            else {
                await axios.post(`${GetBaseUrl()}/apis/follow`, { userid: userShareId }, { headers: { Authorization: `Bearer ${token}` } })
                await updateVideoInfo(_id)
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    handleClickCloseVideoReport = () => this.setState({ isOpenReportPopup: false, reportValue: "a" })

    handleChangeReportValue = (e) => {
        this.setState({
            reportValue: e.target.value
        })
    }

    handleClickVideoReport = (id) => {
        const token = localStorage.getItem("token")
        if (!token) return this.props.loginRequest()
        this.setState({
            isOpenReportPopup: true,
        })
    }

    handleClickPopupCloseBtn = () => this.setState({ isBtnDialogOpened: false })

    handleClickVideoShare = (videoInfo) => {
        this.setState({ isOpenShareDialog: true, selectedVideo: videoInfo })
    }

    handleClickCloseShareDialog = () => this.setState({ isOpenShareDialog: false })

    handleClickUserInfoNickName = (shareId, userId) => {
        if (shareId === '') return
        if (window.location.pathname.startsWith('/user-gallery')) return

        this.props.history.push(`/user-gallery/${shareId}`)
    }

    handleClickUseTemplate = async () => {
        await this.props.moveOriginanlTemplate()

        for (let i = 0; i < 50; i++) {
            if (this.videoRef) {
                this.videoRef.pause()
                break
            }
            await sleep(100)
        }
    }

    handleClickEditHashtagBtn = () => {
        const { videoInfo } = this.props

        this.setState({
            isOpenEditHashtagDialog: true,
            hashtagString: videoInfo.hashtag ? videoInfo.hashtag : ''
        })
    }

    handleChangeEditHashTagDialog = input => {
        if (this.needUpdateHashtagInput) {
            this.needUpdateHashtagInput = false
            input = FormatHelper.convertToTagString(input)
        }
        else if (input.includes(' ')) {
            this.needUpdateHashtagInput = true
            input = FormatHelper.convertToTagString(input)
        }
        else if (input.includes('##')) {
            input = FormatHelper.convertToTagString(input)
        }
        else {
            input = FormatHelper.removeTagStringSpecialCharacters(input)
        }
        this.setState({ hashtagString: input })
    }

    handleCloseEditHashTagDialog = () => {
        this.setState({ isOpenEditHashtagDialog: false, hashtagString: '' })
    }

    handleConfirmEditHashTagDialog = async () => {
        let { hashtagString } = this.state

        if (!hashtagString) {
            hashtagString = this.getNoWhiteSpacehashTags()
        }
        else {
            hashtagString = FormatHelper.convertToTagString(hashtagString)
        }

        if (hashtagString.length === 1 && hashtagString[0] === '#') {
            hashtagString = ''
        }
        else if (hashtagString.length > 1 && hashtagString[hashtagString.length - 1] === '#') {
            hashtagString = hashtagString.substring(0, hashtagString.length - 1)
        }

        this.props.onUpdateHashTag(hashtagString)
        this.handleCloseEditHashTagDialog()
    }

    handleClickCommentUserNickname = (shareId, userId) => {
        if (!shareId) return
        const nxtPath = `/user-gallery/${shareId}`

        if (nxtPath === window.location.pathname) return
        this.props.history.push(nxtPath)
    }

    handleClickRemoveCommentDialog = (comment) => {
        this.setState({
            isOpenRemoveCommentTwoButton: true,
            commentId: comment.id,
        })
    }

    handleCloseRemoveComment = () => {
        this.setState({
            isOpenRemoveCommentTwoButton: false,
            commentId: null
        })
    }

    handleClickCloseCommentReport = () => this.setState({ isOpenCommentReportPopup: false, commentReportValue: "a" })

    handleClickCloseDialog = () => {
        const { onClose } = this.props
        const { textValue, hashtagString } = this.state
        
        onClose()
        if (textValue || hashtagString) {
            this.setState({ textValue: '', hashtagString: '' })
        }
    }

    commentRemove = async () => {
        const token = localStorage.getItem("token")
        const { commentId } = this.state
        const { _id } = this.props.videoInfo
        if (!token) return this.props.loginRequest()

        try {
            await axios.post(`${GetBaseUrl()}/api/video/delete-comment`, { id: _id, commentid: commentId }, { headers: { Authorization: `Bearer ${token}` } })
            await this.props.updateVideoInfo(_id)
            this.setState({ dialogType: "commentRemove" })
            this.handleCloseRemoveComment()
        }
        catch (err) {
            this.handleCloseRemoveComment()
        }
    }

    commentReport = (comment) => {
        const token = localStorage.getItem("token")
        if (!token) return this.props.loginRequest()

        this.setState({
            isOpenCommentReportPopup: true,
            commentId: comment.id
        })
    }

    lastPutTime = 0
    commentEnter = (videoId) => async (e) => {
        if (Date.now() - this.lastPutTime < 5000) return
        this.lastPutTime = Date.now()

        const { textValue } = this.state
        const token = localStorage.getItem("token")
        if (!token) this.props.loginRequest()

        if (this.state.textValue.length === 0) return
        if (this.props.currentUser === undefined) { return this.props.loginRequest() }
        try {
            await axios.post(`${GetBaseUrl()}/api/video/put-comment`, { id: videoId, comment: textValue }, { headers: { Authorization: `Bearer ${token}` } })
            await this.props.updateVideoInfo(videoId)
            this.setState({ textValue: "" }, () => this.CommentAreaRef.scrollTo({ top: this.CommentAreaRef.scrollHeight, left: 0, behavior: 'smooth' }))
        }
        catch (err) {
            this.setState({ textValue: "" })
        }
    }

    changeCommentInput = (e) => {
        this.setState({ textValue: e.target.value })
    }

    changeCommentReportValue = (e) => {
        this.setState({
            commentReportValue: e.target.value
        })
    }

    commentSendReport = async () => {
        const token = localStorage.getItem("token")
        const { _id } = this.props.videoInfo
        const { commentId, commentReportValue } = this.state
        try {
            const result = await axios.post(`${GetBaseUrl()}/api/video/report-comment`, { id: _id, commentid: commentId, value: commentReportValue }, { headers: { Authorization: `Bearer ${token}` } })
            if (result.data && result.data.message === "success") {
                this.handleClickCloseCommentReport()
                this.setState({
                    dialogType: "reportSucces",
                    isBtnDialogOpened: true
                })
            } else if (result.data && result.data.message === "already") {
                this.handleClickCloseCommentReport()
                this.setState({
                    dialogType: "reportAlready",
                    isBtnDialogOpened: true
                })
            }
            if (result && result.status === 404) {
                this.setState({
                    dialogType: "severError",
                    isBtnDialogOpened: true
                })
            }
        } catch (err) {
            this.setState({
                dialogType: "severError",
                isBtnDialogOpened: true
            })
        }
    }

    render() {
        const {
            open,
            videoInfo,
            currentUser,
            heartClick,
            originalTemplate,
            getOriginalTemplateInfo,
            isOriginalDesignDialogOpened,
            history,
            closeOrigianlDialog,
            updateSelectedTemplate,
            onVideoLikedButtonClicked,
            onClickHashTag,
            lang,
            blockUsers
        } = this.props
        
        const {
            reportValue,
            isOpenReportPopup,
            dialogType,
            isBtnDialogOpened,
            isOpenShareDialog,
            isOpenEditHashtagDialog,
            commentId,
            textValue,
            commentReportValue,
            isOpenCommentReportPopup,
            isOpenRemoveCommentTwoButton
        } = this.state

        if (!videoInfo) {
            return (
                <Dialog fullWidth={this.props.fullWidth} maxWidth={"md"} open={open}>
                    <Container>
                        <div className="closeBtn" onClick={this.handleClickCloseDialog}>
                            <div className="closeBar1" />
                            <div className="closeBar2" />
                        </div>
                        <div style={{ margin: "auto", display: "flex", flexDirection: "column" }}>
                            <span className="share_empty-text">{i18n.t("mobile.share.error")}</span>
                        </div>
                    </Container>
                </Dialog>
            )
        }

        const userProfile = videoInfo.profileURL || 'baseImg'

        const isLogined = (localStorage.getItem("token")) ? true : false
        const isMine = (currentUser) ? videoInfo.id === currentUser._id : false
        const viewCount = FormatHelper.convertToKMB(videoInfo.viewCount)
        const hashTags = videoInfo.hashtag ? videoInfo.hashtag.split(' ') : []
        const noWhiteSpaceHashTag = this.getNoWhiteSpacehashTags()
        let filteredComment = Array.isArray(videoInfo.comments) ? videoInfo.comments : []
        if (blockUsers && Object.keys(blockUsers).length > 0 && filteredComment.length > 0) {
            filteredComment = filteredComment.filter(item => !blockUsers[item.userid])
        }

        return (
            <Dialog open={open} onClose={this.handleClickCloseDialog} fullWidth={false} maxWidth={false}>
                <div className='gallery-dialog-new-container'>
                    <div className='gallery-body'>
                        <div className='gallery-body-left'>
                            <video src={videoInfo.url} ref={ref => this.videoRef = ref} controls autoPlay muted controlsList='nodownload'>
                                <source type="video/mp4" src={videoInfo.url}></source>
                            </video>
                        </div>
                        <div className='gallery-body-right'>
                            <div className={`info-area-wrapper ${lang}`}>
                                <div className='gallery-close'>
                                    <img src='https://front.videomonster.com/images-u6yd72dy/web/newgallery/DialogClose.svg' onClick={this.handleClickCloseDialog} alt='close' />
                                </div>
                                <div className='user-info-area'>
                                    <div className='user-profile'>
                                        <img className='user-profile'
                                            src={userProfile === 'baseImg' ? "https://front.videomonster.com/images-u6yd72dy/common/v2-profile.svg" : userProfile}
                                            alt="icon-profile"
                                            onClick={() => this.handleClickUserInfoNickName(videoInfo ? videoInfo.userShareId : '', videoInfo ? videoInfo.id : '')} />
                                    </div>
                                    <div className='user-nickname' onClick={() => this.handleClickUserInfoNickName(videoInfo.userShareId ? videoInfo.userShareId : '', videoInfo.userShareId ? videoInfo.id : '')}>
                                        {videoInfo.username}
                                    </div>
                                    <div className='user-follow'>
                                        {
                                            !isMine
                                            &&
                                            <img
                                                alt='follow'
                                                src={(videoInfo.isFollowed ? videoInfo.isFollowed : '') ? 'https://front.videomonster.com/images-u6yd72dy/web/newgallery/userFollow.svg' : 'https://front.videomonster.com/images-u6yd72dy/web/newgallery/userFollowBefore.svg'}
                                                onClick={() => this.handleClickFollow(videoInfo.userShareId ? videoInfo.userShareId : '', videoInfo.isFollowed ? videoInfo.isFollowed : '')}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='video-info-area'>
                                    <div className='video-name'>{videoInfo.name}
                                        {
                                            (videoInfo ? videoInfo.isStaffPick : '') ? <img src='https://front.videomonster.com/images-u6yd72dy/web/newgallery/staffPick.svg' alt='viewCount' /> : ''
                                        }
                                    </div>
                                    <div className='video-hashTag'>
                                        {
                                            hashTags && hashTags.length > 0
                                                ?
                                                hashTags.map(tag => {
                                                    return <span className="hashTag-name" onClick={() => { onClickHashTag(tag) }}>{tag} </span>
                                                })
                                                :
                                                (isMine && isLogined) ?
                                                    <span className="no-hashTag-name">{i18n.t("web.gallery.detail.plz.input.hashtag")}</span>
                                                    :
                                                    <span className="hashTag-name hidden">hidden text</span>
                                        }
                                        {
                                            (isMine && isLogined) &&
                                            <img
                                                className="edit-hashTag-btn"
                                                src={'https://front.videomonster.com/images-u6yd72dy/web/hashtagEditIcon.svg'}
                                                alt='icon-hashtag-edit'
                                                onClick={() => { this.handleClickEditHashtagBtn() }}
                                            />
                                        }
                                    </div>
                                    <div className='video-info'>
                                        <div className='view-count'>
                                            <img src='https://front.videomonster.com/images-u6yd72dy/web/newgallery/videoView.svg' alt='viewCount' />
                                            <span className='viewCount'>{viewCount}</span>
                                        </div>
                                        <div className='liked-count'>
                                            <img
                                                className='liked-img'
                                                alt='heartIcon'
                                                src={(videoInfo.isLike ? videoInfo.isLike : '') ? 'https://front.videomonster.com/images-u6yd72dy/web/newgallery/videoLiked_red.svg' : 'https://front.videomonster.com/images-u6yd72dy/web/newgallery/videoLiked.svg'}
                                                onClick={(e) => heartClick(videoInfo._id, e)}
                                            />
                                            <span className='likedCount'>{videoInfo.likeMembers}</span>
                                        </div>
                                        <div className='comment-count'>
                                            <img src='https://front.videomonster.com/images-u6yd72dy/web/newgallery/videoComment.svg' alt='commentIcon' />
                                            <span className='commentCount'>{filteredComment.length}</span>
                                        </div>
                                        <div className='video-function'>
                                            <img src='https://front.videomonster.com/images-u6yd72dy/web/newgallery/videoShare.svg' onClick={this.handleClickVideoShare} alt='shareIcon' />
                                            {
                                                !isMine &&
                                                <img src='https://front.videomonster.com/images-u6yd72dy/web/newgallery/videoReport.svg' onClick={this.handleClickVideoReport} alt='reportIcon' />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CommentArea
                                commentList={filteredComment}
                                currentUser={currentUser}
                                notSharedText={i18n.t("web.shared.not.share.text")}
                                onRemove={this.handleClickRemoveCommentDialog}
                                onReport={this.commentReport}
                                selectedComment={commentId}
                                setCommentArea={this.setCommentArea}
                                onClickNickname={this.handleClickCommentUserNickname}
                                textValue={textValue}
                                setFocus={this.setFocus}
                                onInputChange={this.changeCommentInput}
                                onInputClick={this.commentEnter(videoInfo._id)}
                            />
                            <div className='template-btn-wrapper'>
                                <div className='use-template-area'>
                                    <div className='use-template-button' onClick={() => this.handleClickUseTemplate()}>
                                        {i18n.t("mobile.gallery.show.origanltemplate")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ReportVideoPopup
                    reportValue={reportValue}
                    onChange={this.handleChangeReportValue}
                    open={isOpenReportPopup}
                    onClose={this.handleClickCloseVideoReport}
                    sendReport={this.sendReport}
                />
                <OneBtnDialog
                    dialogType={dialogType}
                    open={isBtnDialogOpened}
                    closeBtn={this.handleClickPopupCloseBtn}
                    onButtonClick={this.handleClickPopupCloseBtn}
                />
                <ShareDialog
                    open={isOpenShareDialog}
                    onClose={this.handleClickCloseShareDialog}
                    onShare={this.props.clickShareItem}
                />
                {
                    getOriginalTemplateInfo &&
                    <DesignSelectPopup
                        isDialogOpened={isOriginalDesignDialogOpened}
                        selectedVideo={originalTemplate}
                        templateGroupMap={this.props.templateGroupMap}
                        onVideoLikedButtonClicked={onVideoLikedButtonClicked}
                        history={history}
                        changeSelectedVideo={updateSelectedTemplate}
                        closeDialog={closeOrigianlDialog}
                    />
                }
                <EditHashTagDialog
                    open={isOpenEditHashtagDialog}
                    hashtags={noWhiteSpaceHashTag}
                    onChange={this.handleChangeEditHashTagDialog}
                    onClose={this.handleCloseEditHashTagDialog}
                    onConfirm={this.handleConfirmEditHashTagDialog}
                />
                <CommentReportDialog
                    reportValue={commentReportValue}
                    onChange={this.changeCommentReportValue}
                    open={isOpenCommentReportPopup}
                    onClose={this.handleClickCloseCommentReport}
                    sendReport={this.commentSendReport}
                />
                <TwoBtnDialog
                    open={isOpenRemoveCommentTwoButton}
                    onClose={this.handleCloseRemoveComment}
                    onClick={this.commentRemove}>
                    <div>{i18n.t("web.shared.delete.comment")}</div>
                </TwoBtnDialog>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    value: state.langStore.lang,
    lang: state.langStore.lang,
    blockUsers: state.blockUserStore.blockUsers
})

export default connect(mapStateToProps, null)(NewGalleryDialog)